import { CommitteeModel, CommitteeModelExtended } from "@api/models/committees/CommitteeModel";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import { CommitteeModelMapper } from "@share/committees/committee-form/helpers/CommitteeModelMapper"
import {  CommitteeFormModelInterface } from "@share/committees/committee-form/types/CommitteeFormModel";
import { rawConverter } from "@api/models/objects/Converters";

export class CommitteeFormService {
    constructor(
        private readonly objectRepository: ObjectRepository
    ) {
    }

    private readonly COMMITTEES_SCHEMA_ID = "Committees";

    /**
     * save committee (create and update)
     * @param formModel
     * @returns
     */
    save(formModel: CommitteeFormModelInterface) {

        const committee = CommitteeModelMapper.fromForm(formModel);

        if(!formModel.id) {
            return this.create(committee);
        }
        else {
            return this.update(committee);
        }
    }

    /**
     * Returns committee by id
     * @param id
     * @returns
     */
    async getCommittee(id: string) {
        const query = {
            take: 1,
            where: {
                id: id
            },
            include: [
                'id', 'title', 'description', 'userIds', 'ticketIds',
                'beginAt', 'endAt', 'subjectType', 'location',
                'link', { 'company': ['id', 'title'] },'secretary',
            ]
        }

        return await this.objectRepository.query<CommitteeModelExtended[]>(this.COMMITTEES_SCHEMA_ID, query, rawConverter);
    }

    private create(committee: CommitteeModel) {
        return this.objectRepository.create<CommitteeModel>(this.COMMITTEES_SCHEMA_ID, committee);
    }

    private async update(committee: CommitteeModel) {
        return (await this.objectRepository.update<CommitteeModel>(this.COMMITTEES_SCHEMA_ID, committee.id, committee)).data;
    }
}